// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__TOLV-","location":"Header_location__1tovX"};